'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dUnknown$002dPage from "./presto.-Unknown-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_UnknownPage$() {
}
export { $c_Lpresto_UnknownPage$ as $c_Lpresto_UnknownPage$ };
$p = $c_Lpresto_UnknownPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_UnknownPage$;
/** @constructor */
function $h_Lpresto_UnknownPage$() {
}
export { $h_Lpresto_UnknownPage$ as $h_Lpresto_UnknownPage$ };
$h_Lpresto_UnknownPage$.prototype = $p;
$p.l = (function() {
  return "UnknownPage";
});
$p.cHd = (function(x$0) {
  return new $j_presto$002e$002dUnknown$002dPage.$c_Lpresto_UnknownPage(x$0.j(0));
});
var $d_Lpresto_UnknownPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_UnknownPage$, "presto.UnknownPage$", ({
  U7: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_UnknownPage$ as $d_Lpresto_UnknownPage$ };
var $n_Lpresto_UnknownPage$;
function $m_Lpresto_UnknownPage$() {
  if ((!$n_Lpresto_UnknownPage$)) {
    $n_Lpresto_UnknownPage$ = new $c_Lpresto_UnknownPage$();
  }
  return $n_Lpresto_UnknownPage$;
}
export { $m_Lpresto_UnknownPage$ as $m_Lpresto_UnknownPage$ };
//# sourceMappingURL=presto.-Unknown-Page$.js.map
